var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.17 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.03,71.29l-19.39-18.35c-9.02-8.55-23.16-8.55-32.18,0l-19.41,18.35c-11.12,10.11-3.1,29.44,11.92,28.68,8.14-.22,14.76-4.39,23.56-4.23,9.12-.16,15.89,3.52,24.08,4.23,14.76.34,22.39-18.77,11.42-28.68ZM93.31,88.04c-1.94,4.96-6.8,8.14-12.12,7.95-7.65-1.11-14.38-4.33-23.64-4.21-9.26.12-15.89,3.97-24.08,4.23-6.97.05-12.65-5.56-12.7-12.52-.03-3.54,1.43-6.92,4.02-9.33l19.39-18.26c7.5-7.09,19.23-7.09,26.74,0l19.39,18.35c3.75,3.53,4.94,9.01,3,13.79Z",
    fill: "#2cc749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.05,25.96c-7.59-1.49-13.39,6.95-14.9,14.22-4.53,22.51,17.28,26.8,22.39,4.97,2.09-9.36-1.21-17.8-7.49-19.19ZM110.67,44.3c-4.25,16.88-17.88,13.91-14.64-3.24,3.46-15.36,17.76-15.55,14.64,3.24Z",
    fill: "#2cc749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.89,38.12c7.55,0,13.69-8.58,13.69-19.11-.75-25.35-26.62-25.35-27.35,0,0,10.53,6.14,19.11,13.67,19.11ZM74.89,3.87c12.81.87,12.81,29.4,0,30.27-12.81-.87-12.79-29.4,0-30.27Z",
    fill: "#2cc749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.95,40.19c-1.49-7.27-7.31-15.71-14.9-14.22C-6.02,29.52-.06,59.49,13.69,59.57c7.79-.26,11.38-9.3,9.26-19.39ZM14.6,55.5c-9.79,1.47-15.2-22.86-5.7-25.65,5.72-.56,8.94,6.18,10.17,11.2,1.55,6.89-.5,13.57-4.47,14.44Z",
    fill: "#2cc749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.21,38.12c7.53,0,13.67-8.58,13.67-19.11-.73-25.35-26.6-25.35-27.35,0,0,10.53,6.14,19.11,13.69,19.11ZM40.21,3.87c12.81.87,12.79,29.4,0,30.27-12.81-.87-12.81-29.4,0-30.27Z",
    fill: "#2cc749"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetGreen);
export default __webpack_public_path__ + "static/media/pet-green.a5f30d1ca911cfb8af563433fbc0c400.svg";
export { ForwardRef as ReactComponent };